const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  console.error('REACT_APP_API_URL nie jest zdefiniowany w zmiennych środowiskowych');
}

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};

export const api = {
  // Autoryzacja
  login: async (email, password) => {
    const response = await fetch(`${API_URL}/api/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd logowania');
    }
    return data;
  },

  registerInit: async (email, password) => {
    const response = await fetch(`${API_URL}/api/register/init`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas inicjalizacji rejestracji');
    }
    return data;
  },

  registerVerify: async (verificationId, code) => {
    const response = await fetch(`${API_URL}/api/register/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: verificationId, code })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas weryfikacji kodu');
    }
    return data;
  },

  // Listy słówek
  getWordLists: async () => {
    const response = await fetch(`${API_URL}/api/word-lists`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania list');
    }
    return data;
  },

  createWordList: async (listData) => {
    const response = await fetch(`${API_URL}/api/word-lists`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(listData)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas tworzenia listy');
    }
    return data;
  },

  getWordList: async (id) => {
    const response = await fetch(`${API_URL}/api/word-lists/${id}`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania listy');
    }
    return data;
  },

  deleteWordList: async (id) => {
    const response = await fetch(`${API_URL}/api/word-lists/${id}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas usuwania listy');
    }
    return data;
  },

  updateWordList: async (id, listData) => {
    const response = await fetch(`${API_URL}/api/word-lists/${id}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(listData)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas aktualizacji listy');
    }
    return data;
  },

  // Słówka
  getWords: async (listId) => {
    const response = await fetch(`${API_URL}/api/words/list/${listId}`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania słówek');
    }
    return data;
  },

  createWord: async (listId, wordData) => {
    const response = await fetch(`${API_URL}/api/words/list/${listId}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(wordData)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas tworzenia słówka');
    }
    return data;
  },

  deleteWord: async (id) => {
    const response = await fetch(`${API_URL}/api/words/${id}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas usuwania słówka');
    }
    return data;
  },

  updateWord: async (id, wordData) => {
    const response = await fetch(`${API_URL}/api/words/${id}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(wordData)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas aktualizacji słówka');
    }
    return data;
  },

  toggleFavorite: async (id) => {
    const response = await fetch(`${API_URL}/api/words/${id}/favorite`, {
      method: 'POST',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas aktualizacji ulubionych');
    }
    return data;
  },

  moveWords: async (wordIds, newWordListId) => {
    const response = await fetch(`${API_URL}/api/words/move`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ wordIds, newWordListId })
    }); 
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas przenoszenia słówek');
    }
    return data;
  },

  // Języki
  getLanguages: async () => {
    const response = await fetch(`${API_URL}/api/languages`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania języków');
    }
    return data;
  },

  setLearningLanguage: async (languageId) => {
    const response = await fetch(`${API_URL}/api/languages/set-learning-language`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ languageId })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas ustawiania języka nauki');
    }
    return data;
  },

  generateWords: async (data) => {
    const response = await fetch(`${API_URL}/api/wordsGeneration/generate_words`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Wystąpił błąd podczas generowania słówek');
    }

    return response.json();
  },

  // Gry
  generateDefinitionGame: async (id_listy, liczba_slowek, id_tagu) => {
    const response = await fetch(`${API_URL}/api/games/definition_game/generate_definition`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ id_listy, liczba_slowek, id_tagu })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Błąd podczas generowania definicji');
    }

    return response.json();
  },

  // Tagi
  getTagsByWordList: async (wordListId) => {
    const response = await fetch(`${API_URL}/api/tags/word-list/${wordListId}`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania tagów');
    }
    return data;
  },

  getTags: async (wordListId) => {
    const response = await fetch(`${API_URL}/api/tags/word-list/${wordListId}`, {
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas pobierania tagów');
    }
    return data;
  },

  createTag: async (tagData) => {
    const response = await fetch(`${API_URL}/api/tags`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(tagData)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas tworzenia tagu');
    }
    return data;
  },

  deleteTag: async (tagId) => {
    const response = await fetch(`${API_URL}/api/tags/${tagId}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas usuwania tagu');
    }
    return data;
  },

  addTagToWord: async (wordId, tagId) => {
    const response = await fetch(`${API_URL}/api/tags/word/${wordId}/tag/${tagId}`, {
      method: 'POST',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas dodawania tagu do słówka');
    }
    return data;
  },

  removeTagFromWord: async (wordId, tagId) => {
    const response = await fetch(`${API_URL}/api/tags/word/${wordId}/tag/${tagId}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Błąd podczas usuwania tagu ze słówka');
    }
    return data;
  },

  // Fiszki
  createFlashcardSession: async (wordListId = null, tagId = null, sessionId = null) => {
    const response = await fetch(`${API_URL}/api/games/flashcard_game/create_session`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        word_list_id: wordListId,
        tag_id: tagId,
        session_id: sessionId
      }),
    });
    return response.json();
  },

  deactivateFlashcardSession: async () => {
    const response = await fetch(`${API_URL}/api/games/flashcard_game/deactivate_active_session`, {
      method: 'POST',
      headers: getHeaders()
    });
    return response.json();
  },

  isActiveFlashcardSession: async () => {
    const response = await fetch(`${API_URL}/api/games/flashcard_game/is_active_session`, {
      headers: getHeaders()
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Błąd podczas sprawdzania aktywnej sesji');
    }

    return response.json();
  },

  getActiveFlashcardSession: async () => {
    const response = await fetch(`${API_URL}/api/games/flashcard_game/get_active_session`, {
      headers: getHeaders()
    });

    if (!response.ok) {
      if (response.status === 400) {
        return null; // Brak aktywnej sesji
      }
      const error = await response.json();
      throw new Error(error.error || 'Błąd podczas pobierania aktywnej sesji');
    }

    return response.json();
  },

  updateFlashcardStatus: async (sessionId, cardId, isKnown) => {
    if (!sessionId || !cardId) {
      throw new Error('Brak wymaganych parametrów: sessionId lub cardId');
    }

    const response = await fetch(`${API_URL}/api/games/flashcard_game/update_card_status`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ 
        session_id: sessionId, 
        card_id: cardId, 
        is_known: isKnown 
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Błąd podczas aktualizacji statusu fiszki');
    }

    return response.json();
  },

  getFlashcardSessionStats: async (sessionId) => {
    if (!sessionId) {
      throw new Error('Brak identyfikatora sesji');
    }

    const response = await fetch(`${API_URL}/api/games/flashcard_game/session_stats/${sessionId}`, {
      headers: getHeaders()
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Błąd podczas pobierania statystyk sesji');
    }

    return response.json();
  },

  getSentence: async (wordId) => {
    const response = await fetch(`${API_URL}/api/games/flashcard_game/get_sentence`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ word_id: wordId })
    });
    return response.json();
  },

  // Użycie
  getUserUsage: async () => {
    const response = await fetch(`${API_URL}/api/user/usage`, {
      headers: getHeaders()
    });
    return response.json();
  },

  // Limity użytkownika
  getUserLimits: async () => {
    const response = await fetch(`${API_URL}/api/user/limits`, {
      headers: getHeaders()
    });
    return response.json();
  }
}; 
